<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      ref="tabs"
      v-model="search.year"
      pills
      class="mb-4"
      @input="getReportClaimMember()"
    >
      <b-tab
        v-for="(item, index) in options.year"
        :key="index"
        :title="item.label"
      />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    >
      <template #custom-foot>
        <tr>
          <td class="text-center">備註</td>

          <td colspan="6">已身故未申請理賠者不列入計算</td>
        </tr>
      </template>

      <template #cell(total_number)="row">
        <span
          :class="{'link': row.item.isOpenContractModal && row.item.total_number !== 0}"
          @click="row.item.isOpenContractModal && row.item.total_number !== 0 ? openContractModal(row.item) : null"
        >
          {{ row.item.total_number }}
        </span>
      </template>
    </tables-page>

    <!-- 契約 modal -->
    <death-member-claim-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import DeathMemberClaimContractModal from"./components/modal/DeathMemberClaimContractModal";
import { handleNaN } from "@/models/HELPERS/common.js";

export default {
  name: 'deathMemberClaim',
  components: {
    BreadCrumb,
    TablesPage,
    DeathMemberClaimContractModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '身故會員理賠分布', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false
      },
      options: {
        year: [],
      },
      search: {
        year: 0
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "count",
            label: "年資",
          },
          {
            key: "A",
            label: "A組"
          },
          {
            key: "A_percentage",
            label: "%",
          },
          {
            key: "B",
            label: "B組"
          },
          {
            key: "B_percentage",
            label: "%",
          },
          {
            key: "total_number",
            label: "身故總件數",
          },
          {
            key: "all_percentage",
            label: "%",
          },
        ],
        temp_table_data: {}
      },
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.generateYearArray();
    },
    // 產生年份陣列資料
    generateYearArray() {
      const currentYear = new Date().getFullYear(); // Get current year in AD
      const startYearROC = 109; // Start year in ROC
      const endYearROC = currentYear - 1911; // End year in ROC

      const yearArray = Array.from({ length: currentYear - (startYearROC + 1911) + 1}, (num, index) => {
        const rocYear = endYearROC - index;
        const adYear = currentYear - index;

        return {
          value: index + 1,
          label: `${rocYear}年`,
          key: adYear,
          accept_at_S: `${adYear}-01-01`,
          accept_at_E: `${adYear}-12-31`
        };
      });

      yearArray.unshift({
        value: 0,
        label: '全部',
        key: '',
        accept_at_S: '2000-01-01',
        accept_at_E: ''
      })

      this.options.year = yearArray;
      this.getReportClaimMember();
    },
    // 取得身故會員理賠分布
    getReportClaimMember() {
      const year = this.options.year.find(item => item.value === this.search.year).key;
      const params = {
        year: year
      };

      this.reportApi.getReportClaimMember((response) => {
        const res = response.data;

        this.tableFormatHandler(res.data[0])
      }, params)
    },
    // 表格格式整理
    tableFormatHandler(data) {
      const year = this.options.year.find(item => item.value === this.search.year).label;
      const accept_at = {
        accept_at_S: this.options.year.find(item => item.value === this.search.year).accept_at_S,
        accept_at_E: this.options.year.find(item => item.value === this.search.year).accept_at_E
      };
      const table_classified_data = {
        count_0_30: { count: '0~30天', year: year, apiParams: { claim_day_S: 0, claim_day_E: 30, ...accept_at }, total_number: 0, isOpenContractModal: true },
        count_31_90: { count: '31~90天', year: year, apiParams: { claim_day_S: 31, claim_day_E: 90, ...accept_at }, total_number: 0, isOpenContractModal: true },
        count_91_12: { count: '91天~12個月', year: year, apiParams: { claim_day_S: 91, claim_month_E: 12, ...accept_at }, total_number: 0, isOpenContractModal: true },
        count_13_36: { count: '13個月~36個月', year: year, apiParams: { claim_month_S: 13, claim_month_E: 36, ...accept_at }, total_number: 0, isOpenContractModal: true },
        count_37_off: { count: '37個月~滿額', year: year, apiParams: { claim_month_S: 37, pay_off_status: 0, ...accept_at }, total_number: 0, isOpenContractModal: true },
        count_off: { count: '滿額', year: year, apiParams: { pay_off_status: 1, ...accept_at }, total_number: 0, isOpenContractModal: true },
        count_total: { count: '總計', total_number: 0, isOpenContractModal: false},
      };

      Object.entries(table_classified_data).forEach(([table_key, table_value]) => {
        this.data.table_fields.forEach(item => {
          const current_key = `${table_key}_${item.key}`;

          const current_A_value = `${table_key}_A`;
          const current_B_value = `${table_key}_B`;

          const current_total_A_value = data['count_total_A'];
          const current_total_B_value = data['count_total_B'];

          if (item.key === 'all_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN((table_classified_data[table_key].total_number / (current_total_A_value + current_total_B_value)) * 100).toFixed(1)}%`
          } else if (item.key === 'A_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN((data[current_A_value] / current_total_A_value * 100)).toFixed(1)}%`
          } else if (item.key === 'B_percentage') {
            table_classified_data[table_key][item.key] = `${handleNaN((data[current_B_value] / current_total_B_value * 100)).toFixed(1)}%`
          } else if (item.key !== 'count' && item.key !== 'total_number') {
            table_classified_data[table_key][item.key] = data[current_key];
            table_classified_data[table_key].total_number += data[current_key];
          }
        });
      })

      this.data.table_data = Object.values(table_classified_data);
    },
    // 開啟契約 modal
    openContractModal(item = null) {
      this.status.contractModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/deathMemberClaim.vue